import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { addBloodProcedureAdministrationItem } from '../../timeline/store/timeline.actions'
import { BloodProductAdministrationConstants } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.constants'
import { resetState } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveBloodProductAdministrationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addBloodProductAdministrationToTimeline } = quickActionsObject
  try {
    if (addBloodProductAdministrationToTimeline) {
      yield put(addBloodProcedureAdministrationItem())
      yield put(resetState())
    }
  } catch (e) {
    yield put(throwPcrException(`saveBloodProductAdministrationQuickActionTimeLineRow() error: ${e}`))
  }
}

export function* saveBloodProductAdministrationQuickActionTimeLineRowSaga() {
  yield takeLatest(
    [BloodProductAdministrationConstants.SET_ADD_TO_TIMELINE],
    performWithMutexHOG,
    saveBloodProductAdministrationQuickActionTimeLineRow
  )
}
